// extracted by mini-css-extract-plugin
module.exports = {"likeComment":"style_likeComment__3Ev_8","item":"style_item__G86Vt","icon":"style_icon__Q4XVz"};